import FintechReasons from "../Compoemnt/HomeSection/FintechReasons";
import HeroSection from "../Compoemnt/HomeSection/Herosection";
import ServicesCarousel from "../Compoemnt/HomeSection/ServicesCarousel";
import StatsAndCTA from "../Compoemnt/HomeSection/StatsAndCTA";
import WhyChooseUs from "../Compoemnt/HomeSection/WhyChooseUs";


export default function Home() {
  return (
    <>
      <HeroSection />
      <WhyChooseUs />
      <FintechReasons />
      <ServicesCarousel />
      <StatsAndCTA />
    </>
  );
}
